module.exports = __webpack_public_path__ + "assets/projects/berlinfuchs/menu.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/berlinfuchs/menu.jpg
// module id = 34
// module chunks = 0